export default "__VITE_ASSET__Czmlw2Uu__"